import { Component, inject, Inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import ArrayStore from "devextreme/data/array_store";
import { Address, addressMerge } from "src/app/backend/models/address";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";
import { PopupComponent } from "src/app/services/popup/popup-component";
import { POPUP_INJECT, PopupRef } from "src/app/services/popup/popup-ref";
import { sntTranslate } from "src/app/support/translate";
import { DxListTypes } from "devextreme-angular/ui/list";
import { first } from "lodash";
import { ModuleService } from "src/app/services/feature-access-control/module.service";
import { MODULES } from "src/app/core/modules";

export type AddressCheckerSelectPopupData = {
  addressResult: Address[];
  originalAddress: Address;
  updatedAddress: Address;
};

@Component({
  selector: "pms-address-checker-select",
  templateUrl: "address-checker-select.component.html",
  styles: `
    :host {
      display: flex;
      flex: 1;
      height: 100%;

      ::ng-deep {
        .dx-list-group-header {
          border-bottom: 0px;
        }

        .dx-list-group-header {
          border-top: 0px;
        }
      }
    }
  `,
  standalone: false
})
export class AddressCheckerSelectComponent implements PopupComponent {
  addressResult: Address[];
  updatedAddress: Address;

  addresses: ArrayStore;

  selectedAddress: Address | undefined;

  isDistrictIncluded = inject(ModuleService).canBeActivatedSync(
    MODULES.PROVINCIA_CLIENTE
  );

  constructor(
    @Inject(POPUP_INJECT.REF)
    private popupRef: PopupRef<Address | undefined>,
    @Inject(POPUP_INJECT.DATA)
    private popupData: AddressCheckerSelectPopupData
  ) {
    this.addressResult = this.popupData.addressResult;
    this.updatedAddress = addressMerge({
      originalAddress: this.popupData.originalAddress,
      updatedAddress: this.popupData.updatedAddress
    });

    if (this.addressResult.length === 0) {
      this.selectedAddress = this.updatedAddress;
    }

    this.addresses = new ArrayStore({
      data: [
        {
          key: `${sntTranslate(marker("Originale"))}:`,
          items: [this.updatedAddress]
        },
        {
          key: `${sntTranslate(marker("Suggeriti"))}:`,
          items: this.addressResult
        }
      ]
    });
  }

  isTitleVisible(): boolean {
    return true;
  }

  getTitle(): string {
    return sntTranslate(marker("Modifica indirizzo"));
  }

  async onCancel(buttonClickAsyncEvent: ButtonClickAsyncEvent): Promise<void> {
    await buttonClickAsyncEvent.execute(async () => {
      await this.popupRef.close(undefined);
    });
  }

  async onConfirm(buttonClickAsyncEvent: ButtonClickAsyncEvent): Promise<void> {
    await buttonClickAsyncEvent.execute(async () => {
      await this.popupRef.close(this.selectedAddress);
    });
  }

  isEqual(a: string | undefined, b: string | undefined): boolean {
    return a?.trim().toLowerCase() === b?.trim().toLowerCase();
  }

  normalizzeAddress(route: string, streetNumber: string): string {
    if (!streetNumber) {
      return route;
    }
    return `${route}, ${streetNumber}`;
  }

  onSelectionChanged(
    dxEvent: DxListTypes.SelectionChangedEvent<Address>
  ): void {
    this.selectedAddress = first(dxEvent.addedItems);
  }
}
